import { CONFIRM_FORGOT_PASSWORD_TEXTS } from './confirm-forgot-password.constants';

export const getCognitoErrorMessage = (error): string => {
    if (error.code === 'CodeMismatchException' || error.code === 'ExpiredCodeException') {
        return CONFIRM_FORGOT_PASSWORD_TEXTS.CODE_MISMATCH_OR_EXPIRED_CODE_EXCEPTION;
    }

    return error.message;
};
